module.exports = __webpack_public_path__ + "static/assets/609ff777abc9158ba220550538118ae9.png";